export class EditTableConfig {
    public static readonly NONE = '-';

    public static readonly FINANCE_PAYOUT_CEBUANA = 'finance-payout-cebuana';

    public static readonly FINANCE_XENDIT = 'finance-xendit';

    public static readonly FINANCE_COLLECTION = 'finance-collection';

    public static readonly FINANCE_COLLECTION_PENDING = 'finance-collection-pending';

    public static readonly HOME_TRANSACTIONS = 'home-transactions';

    public static readonly CUSTOMER_QUEST = 'customer-quest';

    public static readonly TOP_UPS = 'finance-top-ups';

    public static readonly CASH_OUT = 'finance-cash-out';

    public static readonly CUSTOMER_XPAY_WALLET = 'finance-customer-xpay-wallet';

    public static readonly DRIVER_WALLET = 'finance-driver-wallet';

    public static readonly DRIVER_WALLET_SUMMARY = 'finance-driver-wallet-summary';

    public static readonly USER_MANAGMENT_ALL_USERS = 'user-managment-all-users';

    public static readonly USER_MANAGMENT_ROLES = 'user-managment-roles';

    public static readonly CAMPAIGN_USERS_USERS = 'campaign-users-users';

    public static readonly CAMPAIGN_USERS_TRANSACTIONS = 'campaign-users-transactions';

    public static readonly OPERATOR_REPORTS = 'operator-reports';

    public static readonly OPERATOR_TRANSACTIONS = 'operator-transactions';

    public static readonly APPLICATION_AUDIT = 'application-audit';

    public static readonly TODAs = 'todas';

    public static readonly SUSPENDED_USERS = 'Suspended Users';

    public static readonly BLACKLISTED_USERS = 'Blacklisted Users';

    public static readonly NEW_APPLICATIONS = 'NewApplications';

    public static readonly MY_APPLICATIONS_NEW = 'MyApplications-New';

    public static readonly MY_APPLICATIONS_PROBATION = 'MyApplications-Probation';

    public static readonly MY_APPLICATIONS_REACTIVATION = 'MyApplications-Reactivation';

    public static readonly REJECTED = 'Rejected';

    public static readonly RESUBMISSION = 'Resubmission';

	public static readonly ORDERS_REPORT = 'ORDERS_REPORT';

	public static readonly REFERRAL_REPORT = 'REFERRAL_REPORT';

	public static readonly CONNEX_BOOKINGS = 'connex-bookings';

    public static readonly NEEDS_REVIEW = 'NEEDS_REVIEW';

    public static readonly IN_PROGRESS = 'IN_PROGRESS';

    public static readonly ON_HOLD = 'ON_HOLD';

    public static readonly DENIED = 'DENIED';

    public static readonly PROBATION = 'PROBATION';
}
